import { HyperFormula } from 'hyperformula';
import { getHyperformulaDateFormats, getSortedFormulaList } from '../utils/tableFormulaUtils';

const hyperFormulaInstance = HyperFormula.buildEmpty({
    licenseKey: 'internal-use-in-handsontable',
    dateFormats: getHyperformulaDateFormats(),
});

export const hyperFormulaList = getSortedFormulaList(hyperFormulaInstance);

export default hyperFormulaInstance;
